module.exports = __webpack_public_path__ + "media/images/alice-b4128710330abee18aa92eee897796cf.svg";